module.exports = __webpack_public_path__ + "img/DAM2.33cca104.jpg";